import React, {useContext, useState} from 'react';
import {Col, Container, Form, Row} from "react-bootstrap";
import {ClearingSystemContext, CLEARING_SYSTEM_CREATE_PAGE, CLEARING_SYSTEM_HOME_PAGE} from "./context";
import {SecurityContext} from "context/security";
import {ToastContext} from "context/Toast";
import * as URL from "service/UrlConstant";

export default function ClearingSystemFilter() {

    const {
        clearingSystemFilterState, setClearingSystemFilterState,
        clearingSystemResultsDisplayState, setClearingSystemResultsDisplayState,
        setShowGridToolbar, clearClearingSystemPanelDisplayState,
        displayClearingSystemPanelPage
    } = useContext(ClearingSystemContext);
    const {makePostRequest} = useContext(SecurityContext);
    const {error} = useContext(ToastContext);
    const [formErrors, setFormErrors] = useState({});

    const handleClear = () => {
        clearClearingSystemPanelDisplayState();
        setFormErrors({});
    }

    const handleChange = (e) => {
        const targetName = e.currentTarget.name;
        const targetValue = e.currentTarget.value;
        const detail = JSON.parse(JSON.stringify(clearingSystemFilterState));
        detail[targetName] = targetValue;
        setClearingSystemFilterState(detail);
    }

    const handleSearch = (e) => {
        e.preventDefault();

        // ensure the result grid is shown (not the create page)
        displayClearingSystemPanelPage(CLEARING_SYSTEM_HOME_PAGE);

        const params = {
            clearingSystemCode: clearingSystemFilterState.clearingSystemCode || null,
            clearingSystemId: clearingSystemFilterState.clearingSystemId || null,
            agentName: clearingSystemFilterState.agentName || null
        }

        const onSuccessResponse = (response) => {
            setShowGridToolbar(response.data.length >= 0);
            const displayState = JSON.parse(JSON.stringify(clearingSystemResultsDisplayState));
            displayState.resData = ([...response.data]);
            displayState.search = params;
            setClearingSystemResultsDisplayState(displayState);
        }
        const onErrorResponse = (err) => {
            console.error(err);
            error("Error searching clearing system data");
        }

        makePostRequest(params, URL.CLEARING_SYSTEM_SEARCH_URL, onSuccessResponse, onErrorResponse);
    }

    const handleCreateNew = (e) => {
        e.preventDefault();
        displayClearingSystemPanelPage(CLEARING_SYSTEM_CREATE_PAGE);
    }

    return (<>
        <Container fluid className="mt-md-3 mt-sm-0">
            <Form>
                <h2 className="d-md-block d-none">Search</h2>
                <Row>
                    <Col sm={12} md={12}>
                        <Form.Group controlId="formClearingSystemCode">
                            <Form.Label className="filter-input-label">Clearing System Code</Form.Label>
                            <Form.Control type="text" name={'clearingSystemCode'}
                                          value={clearingSystemFilterState.clearingSystemCode}
                                          onChange={handleChange}
                                          isInvalid={!!formErrors.clearingSystemCode}/>
                        </Form.Group>
                    </Col>
                    <Col sm={12} md={12}>
                        <Form.Group controlId="formClearingSystemId">
                            <Form.Label className="filter-input-label">Clearing System ID</Form.Label>
                            <Form.Control type="text" name={'clearingSystemId'}
                                          value={clearingSystemFilterState.clearingSystemId}
                                          onChange={handleChange}
                                          isInvalid={!!formErrors.clearingSystemId}/>
                        </Form.Group>
                    </Col>
                    <Col sm={12} md={12}>
                        <Form.Group controlId="formClearingSystemAgentName">
                            <Form.Label className="filter-input-label">Agent Name</Form.Label>
                            <Form.Control type="text" name={'agentName'}
                                          value={clearingSystemFilterState.agentName}
                                          onChange={handleChange}
                                          isInvalid={!!formErrors.agentName}/>
                        </Form.Group>
                    </Col>
                    <Col md={12}>
                        <button className="btn btn-block td-btn-primary-light my-3" onClick={handleSearch}>Search</button>
                    </Col>
                    <Col md={12}>
                        <button className="btn btn-block td-btn-secondary-clear my-3" onClick={handleClear}>Clear</button>
                    </Col>
                    <Col md={12}>
                        <button className="btn btn-block td-btn-secondary-clear my-3" onClick={handleCreateNew}>Create New</button>
                    </Col>
                </Row>
            </Form>
        </Container>
    </>);
}

